import { Store } from '@ngrx/store';
import { map,withLatestFrom } from 'rxjs/operators';
import { State } from '../../../../dave-data-module/State';
import { getOAuthToken } from '../../../../dave-data-module/State/selectors/o-auth-token.selector';
import { getUser } from '../../../../dave-data-module/State/selectors/users.selectors';
import { OAuthType } from '@dave/types';


export function getMySharepointToken(store: Store<State>) {
    return store.select(getOAuthToken).pipe(
        withLatestFrom(store.select(getUser)),
        map(([tokens, user]) => tokens?.find(t => t.Type === OAuthType.MicrosoftSharepoint && t.UserId == user.Id && t.Expired == false)),
    );
}
